// src/components/MapComponent.jsx
import React from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import styles from './MapComponent.module.css';

// Импорт стандартных иконок
import iconBlue   from './img/marker-icon-2x-blue.png';
import iconGold   from './img/marker-icon-2x-gold.png';
import iconRed    from './img/marker-icon-2x-red.png';
import iconGreen  from './img/marker-icon-2x-green.png';
import iconOrange from './img/marker-icon-2x-orange.png';
import iconYellow from './img/marker-icon-2x-yellow.png';
import iconGrey   from './img/marker-icon-2x-grey.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import YouAreHere from './img/YouAreHere.png';

const statusIcons = {
  'Открыта':       iconBlue,
  'Закрыта':       iconGreen,
  'Не доставлено': iconRed,
  'Не доставлен':  iconRed,
  'В процессе':    iconOrange,
  'Ожидает':       iconYellow
};

// Компонент кнопок управления картой
function MapControls({ receiptCenter, userLocation, zoom }) {
  const map = useMap();
  return (
    <div className={styles.mapControls}>
      <button
        type="button"
        className={styles.controlButton}
        title="Где я"
        onClick={() => userLocation && map.flyTo(userLocation, zoom, { animate: true, duration: 1 })}
      >
        <i className="bi bi-crosshair" />
      </button>
      <button
        type="button"
        className={styles.controlButton}
        title="К доставке"
        onClick={() => map.flyTo(receiptCenter, zoom, { animate: true, duration: 1 })}
      >
        <i className="bi bi-house-door-fill" />
      </button>
    </div>
  );
}

export default function MapComponent({ center, zoom, receipts, onMarkerClick, userLocation, allowedUsersLocations }) {
  return (
    <MapContainer
      center={center}
      zoom={zoom}
      style={{ height: '100%', width: '100%' }}
      attributionControl={false}
      className={styles.mapContainer}
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution=""
      />

      {/* Маркеры для чеков */}
      {receipts && receipts.map(receipt => {
        const status = receipt.status;
        const iconUrl = statusIcons[status] || iconGrey;
        const customIcon = new L.Icon({
          iconUrl: iconUrl,
          shadowUrl: iconShadow,
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          shadowSize: [41, 41],
        });
        return (
          <Marker
            key={receipt.id}
            position={[parseFloat(receipt.latitude), parseFloat(receipt.longitude)]}
            icon={customIcon}
            eventHandlers={{ click: () => onMarkerClick(receipt.id) }}
          >
            <Popup>
              <div>
                <p><b>Чек:</b> {receipt.receipt_number}</p>
                <p><b>Статус:</b> <span style={{color: getStatusColor(status)}}>{receipt.status}</span></p>
                <p><b>Клиент:</b> {receipt.client_name}</p>
                <p><b>Адрес:</b> {receipt.delivery_address}</p>
              </div>
            </Popup>
          </Marker>
        );
      })}

      {/* Маркер текущего местоположения пользователя */}
      {userLocation && (
        <Marker
          position={userLocation}
          icon={new L.Icon({
            iconUrl: YouAreHere,
            shadowUrl: iconShadow,
            iconSize: [50, 50],
            iconAnchor: [15, 30],
            popupAnchor: [1, -34],
          })}
        >
          <Popup>Вы здесь</Popup>
        </Marker>
      )}

      {/* Маркеры разрешённых пользователей */}
      {allowedUsersLocations &&
        Object.entries(allowedUsersLocations).map(([userId, loc]) => (
          <Marker
            key={`allowed-${userId}`}
            position={[loc.lat, loc.lng]}
            icon={new L.Icon({
              iconUrl: iconGold,
              shadowUrl: iconShadow,
              iconSize: [25, 41],
              iconAnchor: [12, 41],
              popupAnchor: [1, -34],
              shadowSize: [41, 41],
            })}
          >
            <Popup>Пользователь {userId}</Popup>
          </Marker>
        ))}

      {/* Кнопки управления картой */}
      <MapControls receiptCenter={center} userLocation={userLocation} zoom={zoom} />
    </MapContainer>
  );

  function getStatusColor(status) {
    switch (status) {
      case 'Открыта':       return 'blue';
      case 'Закрыта':       return 'green';
      case 'Не доставлено': return 'red';
      case 'Не доставлен':  return 'red';
      case 'В процессе':    return 'orange';
      case 'Ожидает':       return 'yellow';
      default:              return 'gray';
    }
  }
}